import { useSyncExternalStore } from "react";

// nothing ever changes, so there is nothing to subscribe to - just a stable no-op unsubscribe
function subscribeNever() {
	return () => { };
}

/**
 * false on the server and while hydrating, true in every render after that (and in client-only renders).
 * Use it to read browser-only state (hash, storage) without causing a hydration mismatch,
 * e.g. with React's "adjust state while rendering" pattern.
 */
export default function useIsHydrated(): boolean {
	return useSyncExternalStore(subscribeNever, () => true, () => false);
}
